import * as Sentry from '@sentry/vue'

export default {
  install (Vue) {
    const isEnabled = process.env.VUE_APP_ENV === 'sandbox' || process.env.NODE_ENV === 'production'
    const enableConsoleDebug = !!process.env.VUE_APP_ENV
    const ALLOWED_URLS = [
      // /localhost/,
      // /ciclic\.com\.br/,
      /semprebem\.ciclic\.com\.br/
    ]

    Sentry.init({
      Vue,
      dsn: 'https://28d4a160201ff8f8ac4cdd5bebe090ed@o96223.ingest.sentry.io/4505846271508480',
      release: `pag-${process.env.VUE_APP_JOURNEY_NAME}-front@${process.env.VUE_APP_VERSION}`,
      environment: process.env.VUE_APP_ENV || process.env.NODE_ENV,
      ignoreErrors: [
        '$ is not a function',
        '$ is not defined',
        'Can\'t find variable: $'
      ],
      beforeSend (event) {
        if (
          isEnabled && !blackList(event.message) &&
          ALLOWED_URLS.some(url => url.test(event.request.url))
        ) {
          return event
        }
      }
    })

    Vue.prototype.$sentry = {
      Sentry,
      logWithContext (errorSetting) {
        const { error, ctx = null, tags = null, level = null } = errorSetting

        if (!error) return console.debug('error not sent')

        // eslint-disable-next-line no-console
        if (enableConsoleDebug) console.debug(ctx ? ctx.label : 'Sentry', error)

        const { errorData, hasError } = errorHandling(error)
        if (!isEnabled || !hasError) return

        const scope = new Sentry.Scope()

        if (tags) scope.setTags(tags)
        if (level) scope.setLevel(level)

        scope.setContext('Error information', {
          errorData,
          ...ctx
        })

        Sentry.captureException(error, scope)
      }
    }
  }
}

function errorHandling (error) {
  let errorData = error
  let hasError = true

  if (error.response && error.response.data) {
    errorData = JSON.stringify(error.response.data, null, 2)
    hasError = !blackList(error.response.data.message || '')
  } else if (error.config && error.config.data) {
    errorData = JSON.stringify(error.config.data).replace(/\d/g, '*')
  }

  return { errorData, hasError }
}

function blackList (errorMessage) {
  if (!errorMessage) return false

  const blackList = [
    /Pagamento não autorizado pela empresa de cartão de crédito\. Confira os dados preenchidos ou tente um novo cartão/i,
    /Pagamento não pode ser completado, entre em contato com o emissor do cartão/i,
    /Número de cartão de crédito inválido/i,
    /Transação não autorizada/i,
    /E-mail inválido\. Por favor, verifique o endereço de e-mail preenchido( para envio do voucher)?/i,
    /SecurityError: Permission denied to access property "__ob__" on cross-origin object/i,
    /SecurityError: Blocked a frame with origin "https:\/\/semprebem\.ciclic\.com\.br" from accessing a cross-origin frame(\. Protocols, domains, and ports must match)?/i,
    /JSON parse error: Could not resolve type id '(DEVICES)' as a subtype of \[simple type, class br\.com\.ciclic\.lead\.v\d\.LeadDTO\]:.*/i,
    /Não foi possível processar o seu pagamento. Confira os dados e tente novamente mais tarde/i,
    /Pet sem cor informada/i,
    /CPF, e-mail ou telefone já associado à um plano/i
  ]

  return blackList.some(msg => msg.test(errorMessage))
}
